var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.45,21.75h9.92V23H19.45Zm0,3.72h9.92V24.23H19.45Zm0,2.48h4.34V26.71H19.45Zm0,2.48h4.34V29.19H19.45Zm7.08-1.76-.87-.88-.87.87,1.75,1.76,2.85-2.84-.88-.88Zm-7.08-9.41v1.24h9.92V19.27Z",
    transform: "translate(-12.25 -5.74)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.45,5.74H15.29a3,3,0,0,0-3,3l0,24.32a3,3,0,0,0,3,3H33.53a3,3,0,0,0,3-3V14.86ZM15.29,33.1V8.78H25.93v7.6h7.6V33.1Z",
    transform: "translate(-12.25 -5.74)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.6e212960d1a48c3078481f8d246285e2.svg";
export { ForwardRef as ReactComponent };